/* eslint-disable radix */
import PropTypes from 'prop-types';
import React from 'react';
import { ListGroupItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { userId } from '../../../../reducers/currentUser/currentUser.reducer';
import { assign as assignAction, unassign as unassignAction } from '../../../../reducers/projects/projects.actions';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import './ProjectAssign.css';

// eslint-disable-next-line object-curly-newline
export const ProjectAssign = ({ project: { name, client, id, employees, saving }, assign, unassign }) => {
  const userAssigned = employees.some(e => e.id === Number.parseInt(userId()));

  return (
    <ListGroupItem
      header={client.name}
      key={id}
      className="projectAssign"
    >
      {name}
      {userAssigned &&
      <span className="clearfix" ><SpinnerButton isLoading={saving} onClick={() => unassign(id)} bsStyle="danger">Unassign</SpinnerButton></span> }
      {!userAssigned &&
      <span className="clearfix" ><SpinnerButton isLoading={saving} onClick={() => assign(id)} bsStyle="primary" >Assign</SpinnerButton></span> }
    </ListGroupItem>
  );
};

ProjectAssign.propTypes = {
  project: PropTypes.shape({}).isRequired,
  assign: PropTypes.func.isRequired,
  unassign: PropTypes.func.isRequired,
};

export const mapStateToProps = () => ({});

export const mapDispatchToProps = dispatch => ({
  assign: id => dispatch(assignAction(id)),
  unassign: id => dispatch(unassignAction(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectAssign);



// WEBPACK FOOTER //
// ./src/components/ProjectManager/Projects/ProjectAssign/ProjectAssign.jsx